import * as React from "react";

import { cn } from "~/lib/utils";

/** P0-11 · Text input. `aria-invalid` surfaces the error (danger) border. */
export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      "h-10 w-full rounded-md border border-border bg-surface px-3 text-sm text-fg outline-none transition-[box-shadow,border-color]",
      "placeholder:text-fg-muted focus:border-primary focus:ring-2 focus:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-danger",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
